
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.667 2l2.195 2.195-4.667 4.667.943.943 4.667-4.667L14 7.333V2H8.667z"}}),_c('path',{attrs:{"d":"M12.667 12.667H3.333V3.333H8L6.667 2H3.333C2.598 2 2 2.598 2 3.333v9.334C2 13.402 2.598 14 3.333 14h9.334c.735 0 1.333-.598 1.333-1.333V9.333L12.667 8v4.667z"}})])
          )
        }
      }
    